import React, { useState } from "react";
import { Modal, Header, Button, Form as FormUi, Table } from "semantic-ui-react";
import Axios from "axios";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { translate } from "react-i18next";
import {SUCCESS_MESSAGES , ERROR_MESSAGES} from '../../utils/validationConstant'
import {LOCAL_STORAGE} from '../../utils/constant'

const ImportVendorAllocation = (props) => {
  const [file, setFile] = useState(0);
  const [isloading, setisloading] = useState(false);
  const [fileErrors, setfileErrors] = useState([]);
  const [fileErrorsflag, setfileErrorsFlag] = useState(false);
  const handleFile = (e) => {
    let file = e.target.files[0];
    setFile(file);
  };
  const templateDownload = async () => {
    let fileName = props.fileName;
    let url
    if (props.allotedOrder) {
      url = `${process.env.REACT_APP_TA_API_URL}/orders/download/importExcelSample?fileName=${fileName}`
    } else {
      url = `${process.env.REACT_APP_TA_API_URL}/orders/download/importExcelSample?fileName=allot_vendor`;
    }
    window.location.href = url;
  };
  
  let handleUpload = (e) => {
    e.preventDefault();
    setisloading(true);
    if (file === "" || file === null || file === undefined) {
      setisloading(false);
    } else if (
      file.type !==
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ) {
      setisloading(false);
    } else {
      let fromData = new FormData();
      fromData.append("customerNumber", LOCAL_STORAGE.customerNo);
      fromData.append("userId", LOCAL_STORAGE.userId);
      fromData.append("customer_no", LOCAL_STORAGE.customerNo);
      fromData.append("user_id", LOCAL_STORAGE.userId);
      var gett = LOCAL_STORAGE.userToken
      let url

      fromData.append("allot_vendor", file);
        url = `${process.env.REACT_APP_TA_API_URL}/orders/import/?customer_no=${LOCAL_STORAGE.customerNo}&user_id=${LOCAL_STORAGE.userId}`;
console.log(JSON.stringify(url));
      Axios.post(url, fromData, {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `${gett}`,
        },
      })
        .then((response) => {
          setisloading(false);
          if(props.allotedOrder){
             if(response.data?.resultSet?.skipped_records?.length > 0){
              setfileErrors(response.data.resultSet.skipped_records);
              setfileErrorsFlag(true);
              }else{
                setfileErrorsFlag(false);
              props.success({
                type: "success",
                messageHeader: "Success",
                messageBody: SUCCESS_MESSAGES.FILE_UPLOAD_SUCCESS,
              });
              props.handleClose();
              window.location.reload()
              }
          }else{
            console.log(response)
            if (response?.data?.data?.errors && response?.data?.data?.errors?.length != 0) {
              var errArry = response.data.data.errors;
              let formatted_errors = [];
              for (var errors of errArry) {
                var final_object = {
                  row_no: "",
                  errors: []
                }
                final_object.row_no = errors.row_no
                final_object.errors = errors.errors
                formatted_errors.push(final_object)
              }
              setfileErrors(formatted_errors);
              setfileErrorsFlag(true);
            } else {
              setfileErrorsFlag(false);
              props.success({
                type: "success",
                messageHeader: "Success",
                messageBody: SUCCESS_MESSAGES.FILE_UPLOAD_SUCCESS,
              });
              props.handleClose();
            }
          }
        })
        .catch((err) => {
        //   alert(err.response.data.message);
          console.log(err,'hjhj');
          props.error({
            type: "error",
            messageHeader: "Error",
            messageBody: err.response.data.message||ERROR_MESSAGES.IMPORT_FAILED,
          });
          setisloading(false);
          console.log(">> err", err);
        });
    }
  };

  const { t } = props;
  return (
    <>

      <div>
        <Modal open={props.openBox} onClose={props.handleClose} size="tiny">
          {fileErrorsflag == true ? (
            <>
              <Header>{t("title") || "Import File"}</Header>
              <Modal.Content scrolling>
                <Modal.Description>
                  {/* {fileErrors} */}
                  {fileErrors.map((error, index) => (
                    <Table>
                     {props.allotedOrder ?
                     <Table.Header>
                     <Table.Row>
                       <Table.HeaderCell>
                         {error}
                       </Table.HeaderCell>
                     </Table.Row>
                   </Table.Header> :
                     <>
                      <Table.Header>
                        <Table.Row>
                          <Table.HeaderCell>
                            <label>{ERROR_MESSAGES.ERROR_IN_ROW} &nbsp;</label>{error.row_no}
                          </Table.HeaderCell>
                        </Table.Row>
                      </Table.Header>
                      <Table.Body>
                        {error.errors.map((error, index) => (
                          <Table.Row>
                            <Table.Cell>
                              <label>{ERROR_MESSAGES.ERROR_IN_COLUMN} - &nbsp;</label>{error.column_name}
                              {error.reasons.map((error, index) => (
                                <Table.Row>
                                  <Table.Cell>
                                    {error}
                                  </Table.Cell>
                                </Table.Row>
                              ))}
                            </Table.Cell>
                          </Table.Row>

                        ))}
                      </Table.Body>
                      </>}
                    </Table>
                  ))}
                </Modal.Description>
              </Modal.Content>
              <Modal.Actions>
                <Button onClick={props.handleClose} size="mini">
                  {t("cancel") || "Cancel"}
                </Button>
              </Modal.Actions>
            </>
          ) : (
            <>
              <Header>{t("title") || "Import File"}</Header>
              <Modal.Content>
                <Modal.Description>
                  <FormUi.Group inline>
                    <FormUi.Field>
                      <label className="tiny ui form p-bold-600">
                        {t("message") || "Import Data Using Excel Sheet(Format- xls,xlsx)."}
                      </label>
                    </FormUi.Field>
                  </FormUi.Group>
                  <FormUi.Group inline>
                    <FormUi.Field>
                      <label className="tiny ui form p-bold-300 w3-text-grey  pt-3">
                        {t("upload_file") || "Upload File"} &nbsp;
                      </label>
                      <input
                        onChange={handleFile}
                        type="file"
                        className="w3-small"
                        id="validatedCustomFile"
                      />
                    </FormUi.Field>
                    <FormUi.Field>
                      <label className="tiny ui form pt-3">
                        <span className="p-bold-600 ">
                          {t("download") || "Download Excel Template from"}{" "}
                          <span
                            className="w3-text-blue p-bold-300"
                            onClick={templateDownload}
                            style={{ cursor: "pointer" }}
                          >
                            {t("here") || "Here"}
                          </span>
                        </span>
                      </label>
                    </FormUi.Field>
                  </FormUi.Group>
                </Modal.Description>
              </Modal.Content>
              <Modal.Actions>
                {isloading ? <small>Loading...</small> : ""}
                <Button onClick={()=>props.LoadingOnClose ? props.handleClose(isloading) : props.handleClose()} size="mini">
                  {t("cancel") || "Cancel"}
                </Button>
                <Button
                  onClick={handleUpload}
                  disabled={isloading ? true : false}
                  color="blue"
                  size="mini"
                >
                  {t("upload") || "Upload"}
                </Button>
              </Modal.Actions>

            </>
          )}
        </Modal>
      </div>

    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    success: (alert) => dispatch(successAlertDispatcher(alert)),
    error: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(null, mapDispatchToProps)(translate("importfilemaster")(ImportVendorAllocation));
